import {
  HttpClient,
  HttpErrorResponse,
  HttpEventType,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { JwtService } from "../@core/services/jwt.service";
import { environment } from "../../environments/environment";
import {Injectable, Injector, NgZone} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import { convertPayloadDatetime } from "../@core/utils/utils.service";
import { convertResponseDatetime } from "../@core/utils/utils.service";
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, filter, finalize, map, switchMap, take } from 'rxjs/operators';
import {jwtDecode} from "jwt-decode";
import {AuthService} from "../@core/services/auth.service";
import {
  AQH_CLS_0,
  AQH_EVE_0, AQH_EVE_1,
  AQH_EVE_10, AQH_EVE_11,
  AQH_EVE_12, AQH_EVE_13,
  AQH_EVE_14, AQH_EVE_15, AQH_EVE_16, AQH_EVE_17, AQH_EVE_18, AQH_EVE_19, AQH_EVE_2, AQH_EVE_20, AQH_EVE_21, AQH_EVE_22, AQH_EVE_23, AQH_EVE_24, AQH_EVE_25, AQH_EVE_26, AQH_EVE_27, AQH_EVE_28, AQH_EVE_29, AQH_EVE_30, AQH_EVE_31, AQH_EVE_32, AQH_EVE_33, AQH_EVE_34, AQH_EVE_35, AQH_EVE_36, AQH_EVE_37, AQH_EVE_3, AQH_EVE_4, AQH_EVE_5, AQH_EVE_6, AQH_EVE_7, AQH_EVE_8, AQH_EVE_9,
  AQH_EVE_40, AQH_EVE_41, AQH_EVE_42, AQH_EVE_43, AQH_EVE_44, AQH_EVE_45, AQH_EVE_46, AQH_EVE_47, AQH_EVE_48, AQH_EVE_49, AQH_EVE_50, AQH_EVE_51, AQH_EVE_52, AQH_EVE_53, AQH_EVE_55,
  AQH_EVE_60, AQH_EVE_61, AQH_EVE_62, AQH_EVE_63, AQH_EVE_64, AQH_EVE_65, AQH_EVE_67, AQH_EVE_69, AQH_EVE_70, AQH_EVE_140, AQH_EVE_141, AQH_EVE_142, AQH_EVE_143, AQH_EVE_144, AQH_EVE_150, AQH_EVE_151, AQH_EVE_152,
  AQH_EVE_73, AQH_EVE_74, AQH_EVE_75, AQH_EVE_76, AQH_EVE_77, AQH_EVE_78, AQH_EVE_79, AQH_EVE_80,
  AQH_EVE_90, AQH_EVE_91, AQH_EVE_92, AQH_EVE_93, AQH_EVE_94,
  AQH_EVE_100, AQH_EVE_101, AQH_EVE_102, AQH_EVE_103, AQH_EVE_104, AQH_EVE_105, AQH_EVE_106, AQH_EVE_107, AQH_EVE_108, AQH_EVE_109,
  AQH_EVE_110, AQH_EVE_111, AQH_EVE_112, AQH_EVE_113, AQH_EVE_114, AQH_EVE_115,
  AQH_EVE_120, AQH_EVE_121, AQH_EVE_122, AQH_EVE_123, AQH_EVE_124, AQH_EVE_125,
  AQH_EVE_126, AQH_EVE_127, AQH_EVE_128, AQH_EVE_129,
  AQH_EVE_130, AQH_EVE_131, AQH_EVE_132, AQH_EVE_133, AQH_EVE_134, AQH_EVE_135, AQH_EVE_136, AQH_EVE_137,
  AQH_EVE_160, AQH_EVE_161, AQH_EVE_162,
  AQH_EVE_170, AQH_EVE_171, AQH_EVE_172, AQH_EVE_173, AQH_EVE_174,
  AQH_EVE_180, AQH_EVE_181, AQH_EVE_182, AQH_EVE_183, AQH_EVE_185,
  AQH_TRN_0, AQH_TRN_1, AQH_TRN_2, AQH_TRN_3,
  AQH_TRN_10, AQH_TRN_11, AQH_TRN_12, AQH_TRN_13,
  AQH_TRN_20, AQH_TRN_21, AQH_TRN_22, AQH_TRN_23,
  AQH_TRN_30, AQH_TRN_31, AQH_TRN_32, AQH_TRN_33, AQH_TRN_34,
  AQH_TRN_40, AQH_TRN_41, AQH_TRN_42, AQH_TRN_43, AQH_TRN_44, AQH_TRN_45,
  AQH_CHT_1, AQH_CHT_2, AQH_CHT_3, AQH_CHT_4, AQH_CHT_5, AQH_CHT_6, AQH_CHT_7,
  FEED_1, FEED_3, FEED_4, FEED_5, FEED_6, FEED_7, FEED_8, FEED_9,
  TRN_4, TRN_13, TRN_16, TRN_19,
  AQH_FAM_0,
  AQH_FAM_1, AQH_FAM_2,
  AQH_HOR_0, AQH_HOR_1, AQH_HOR_2, AQH_HOR_3, AQH_HOR_4, AQH_HOR_5, AQH_HOR_6, AQH_MEM_0, AQH_MEM_1, AQH_MEM_2, AQH_MEM_3, AQH_MEM_4, AQH_MEM_5, AQH_MEM_6, AQH_MEM_7, AQH_MEM_8, AQH_MEM_9, AQH_MEM_10, AQH_STA_0, AQH_STA_1, AQH_STA_2,
  COR_COY_0,
  COR_COY_1,
  COR_COY_2,
  COR_COY_3,
  COR_COY_4, COR_COY_5, COR_COY_6, COR_COY_7, COR_COY_8,
  COR_COY_27, COR_COY_28, COR_COY_30, COR_COY_40,
  COR_COY_50, COR_COY_51, COR_COY_52, COR_COY_53, COR_COY_54,
  USM_ENT_0,
  USM_ENT_2,
  USM_ENT_3,
  USM_USR_0,
  USM_USR_1,
  USM_USR_13,
  USM_USR_14,
  USM_USR_16,
  USM_USR_18,
  USM_USR_19,
  USM_USR_22,
  USM_USR_25,
  USM_USR_26, USM_USR_27,
  USM_USR_3,
  USM_USR_34,
  USM_USR_35,
  USM_USR_6
} from "./models/input.module";
import {
  DeleteResponse,
  GetResponse,
  PaginationResponse,
  PostResponse,
  PutResponse
} from "./models/global/response-wrapper.service";
import {
  ApplicationResponse, ApplicationTypeResponse, CandidateCompactResponse, CandidateResponse,
  ClassResponse, CompanyImageResponse,
  CompanyResponse, CompanySponsorResponse, EventClassRegistrationResponse, EventClassResponse, EventClassSponsorResponse, EventContactResponse, EventContactRoleResponse, EventResponse, EventServiceRegistrationResponse, EventServiceResponse, EventSponsorResponse, EventTaskResponse, EventMemberResponse, EventAccessResponse, EventTypeResponse, FamilyMemberResponse,
  HorseRegistryResponse, HorseResponse,
  InvitationTokenVerificationResponse,
  LoginResponse, MembershipPlanResponse, MembershipResponse, SponsorResponse,
  UserEntityRelationWithoutUserDataResponse,
  UserEntityRelationWithUserDataResponse,
  UserOptionsResponse,
  UserResponse,
  EventScheduleResponse, EventScheduleEntryResponse, EventScheduleLiveStatusResponse, EventScheduleGroupResponse,
  EventAnnouncementResponse,
  ConversationResponse, MessageResponse, UnreadCountResponse, UserSearchResult,
  EventTrackResponse, DayBreakResponse,
  StripeConnectStatus, OrderResponse,
  FeedPostResponse, FeedPostImageResponse,
  TrainerResponse, TrainerStatusResponse, TrainerApplicationResponse, TrainerRecommendationResponse,
  CompanyDocumentResponse, CompanyCategoryResponse,
  CompanyServiceResponse, CompanyServiceOrderResponse,
  EventExpenseResponse, EventExpenseImageResponse,
  TrainingPackageResponse, TrainingSessionResponse,
  TrainingRegistrationResponse, TrainingSessionAssignmentResponse,
  TrainingDayCapacityResponse, TrainingPackageDayResponse,
  MembershipPriceResponse, UserPricesResponse,
  EventCoOrganiserResponse, CoOrganisedEventResponse,
  PublicClassResultsResponse, UserResultResponse, ResultImageResponse,
  MarketDealResponse,
  NryfEventResponse, NryfMasterdataResponse,
  CountryResponse,
  AdminDashboardStats, AdminUserResponse, AdminCompanyResponse,
  MyEventMembershipResponse
} from "./models/response.module";
import {Horses} from './services/horses';
export interface EndpointOptions {
  auth?: boolean,
  content_type?: string | null,
  platform?: boolean,
  raiseErrorToast?: boolean,
  useBody?: boolean
}

@Injectable({
  providedIn: 'root',
})
export class EndpointService {
  constructor(private http: HttpClient,
              private jwtService: JwtService,
              private translateService: TranslateService,
              private injector: Injector,
              private zone: NgZone
  ) {}


  private refreshTokenSubject: BehaviorSubject<any | null> = new BehaviorSubject<any | null>(null);
  private refreshTokenInProgress = false;

  refreshToken(): Observable<string> {
    const authService = this.injector.get(AuthService);

    if (this.refreshTokenInProgress) {
      return this.refreshTokenSubject.pipe(
        filter((token) => token !== null),
        take(1)
      );
    }

    this.refreshTokenInProgress = true;
    this.refreshTokenSubject.next(null);

    return authService.refreshToken().pipe(
      switchMap((data) => {
        const newToken = data.access_token;
        this.refreshTokenSubject.next(newToken);
        return of(newToken); // Return the new token
      }),
      catchError((error) => {
        // Handle token refresh error here
        return throwError(error);
      }),
      finalize(() => {
        this.refreshTokenInProgress = false;
      })
    );
  }

  /**
  *
  * Default HTTP functions
  *
  */

  private handleResponse<T>(observable: Observable<T>): Observable<T> {
  return observable.pipe(
    map((res) => {
      if (res) {
        convertResponseDatetime(res);
      }
      return res;
    })
  )};

  private handlePayload(data: any): any {
    if (data) {
      data = convertPayloadDatetime(data);
    }
    return data;
  }

  getDefaultHeaders(auth: boolean = true, content_type: string | null = 'application/json', platform: boolean = false): Observable<HttpHeaders> {
    // Accept-Language
    let headers = new HttpHeaders({
      'Accept-Language': this.translateService.currentLang ? this.translateService.currentLang : 'en',
    });

    // Content-Type
    if (content_type != null) {
      headers = headers.append('Content-Type', content_type);
    }

    // Platform
    if (platform) {
      headers = headers.append('Platform', 'core');
    }

    // Authorization
    if (auth) {
      if (this.jwtService.getAccessToken() == null || this.jwtService.getAccessToken() == undefined || this.jwtService.getAccessToken() == '') {
        throw new Error('No access token found')
      }
      const decodedToken: {[key: string]: string | number} = jwtDecode(this.jwtService.getAccessToken());
      const currentTimestamp = Math.floor(Date.now() / 1000); // Get current Unix timestamp in seconds
      const tokenExpiration = decodedToken["exp"];

      if (tokenExpiration && tokenExpiration < currentTimestamp.toString()) {
        return this.refreshToken().pipe(
          switchMap((newToken) => {
            headers = headers.append('Authorization', 'Bearer ' + newToken);
            return of(headers);
          })
        );
      } else {
        headers = headers.append('Authorization', 'Bearer ' + this.jwtService.getAccessToken());
        return of(headers);
      }
    } else {
      return of(headers);
    }
  }

  // post<R>(url: string, payload: any, auth = true, content_type?: string | null, platform: boolean = false, raiseErrorToast: boolean = true): Observable<R> {
  post<R>(url: string, payload: any, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        payload = this.handlePayload(payload);
        return this.http.post<R>(url, payload, {headers: headers}).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  postMultipart<R>(url: string, formData: FormData, options: EndpointOptions): Observable<R> {
    // For multipart, we need to NOT set Content-Type (let browser handle it)
    return this.getDefaultHeaders(options.auth, null, options.platform).pipe(
      switchMap((headers) => {
        // Remove Content-Type header to let browser set it with boundary for multipart
        headers = headers.delete('Content-Type');
        return this.http.post<R>(url, formData, {headers: headers}).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  put<R>(url: string, payload: any, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        payload = this.handlePayload(payload);
        return this.http.put<R>(url, payload, {headers: headers}).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  patch<R>(url: string, payload: any, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        payload = this.handlePayload(payload);
        return this.http.patch<R>(url, payload, {headers: headers}).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  get<R>(url: string, queryParams: { [key: string]: any } | undefined, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        queryParams = this.handlePayload(queryParams);
        let httpParams = new HttpParams();
        if (queryParams) {
          Object.keys(queryParams).forEach(key => {
            const value = queryParams?.[key];
            if (value !== undefined && value !== null) {
              httpParams = httpParams.set(key, value);
            }
          });
        }

        return this.http.get<R>(url, { headers: headers, params: httpParams }).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  delete<R>(url: string, queryParams: { [key: string]: any } | undefined, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        queryParams = this.handlePayload(queryParams);

        // Use body or query params based on useBody option
        if (options.useBody) {
          // Send payload as request body
          return this.http.delete<R>(url, { headers: headers, body: queryParams }).pipe(
            catchError((error: any) => {
              if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
                // this.toastService.errorToast(error.error.asset_id);
              }
              return throwError(error);
            }),
            switchMap((response: R) => {
              return this.handleResponse<R>(of(response));
            })
          );
        } else {
          // Send payload as query params (default)
          let httpParams = new HttpParams();
          if (queryParams) {
            Object.keys(queryParams).forEach(key => {
              const value = queryParams?.[key];
              if (value !== undefined && value !== null) {
                httpParams = httpParams.set(key, value);
              }
            });
          }
          return this.http.delete<R>(url, { headers: headers, params: httpParams }).pipe(
            catchError((error: any) => {
              if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
                // this.toastService.errorToast(error.error.asset_id);
              }
              return throwError(error);
            }),
            switchMap((response: R) => {
              return this.handleResponse<R>(of(response));
            })
          );
        }
      })
    );
  }


  /**
  *
  * Endpoint definitions
   * USM
   * Users
  *
  */

  usm_aut_0(payload: USM_USR_0, raiseErrorToast: boolean = true): Observable<LoginResponse> {
    let options: EndpointOptions = {
      auth: false,
      content_type: null,
      platform: true,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/login', payload, options)
  }

  usm_aut_1(raiseErrorToast: boolean = true): Observable<LoginResponse> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': this.translateService.currentLang,
      'Authorization': 'Bearer ' + this.jwtService.getRefreshToken(),
      'Platform': 'core'
    })
    let options = {headers: headers}
    return this.http.post<LoginResponse>(environment.coreApiUrl + 'users/refresh-token', {}, options).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse && raiseErrorToast) {
          // this.toastService.errorToast(error.error.asset_id);
        }
        return throwError(error);
      }),
    );
  }

  usm_usr_1(raiseErrorToast: boolean = true): Observable<GetResponse<UserResponse>>  {
    return this.get(environment.coreApiUrl + 'users/', undefined, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_3(payload: USM_USR_3, raiseErrorToast: boolean = true): Observable<PutResponse<UserResponse>> {
    return this.put(environment.coreApiUrl + 'users/', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_6(payload: USM_USR_6, raiseErrorToast: boolean = true): Observable<PostResponse<UserEntityRelationWithUserDataResponse>> {
    return this.post(environment.coreApiUrl + 'users/invite/to-entity', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_13(payload: USM_USR_13, raiseErrorToast: boolean = true): Observable<GetResponse<null>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/reset-password/initiate', payload, options)
  }

  usm_usr_14(payload: USM_USR_14, raiseErrorToast: boolean = true): Observable<PostResponse<null>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/reset-password/token', payload, options)
  }

  usm_usr_16(payload: USM_USR_16, raiseErrorToast: boolean = true): Observable<PutResponse<UserResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // FormData instance
        let formData = new FormData();
        formData.append('image', payload.image);

        // Remove Content-Type to let browser set it with boundary for multipart/form-data
        const uploadHeaders = headers.delete('Content-Type');
        const options = { headers: uploadHeaders };

        return this.http.put<PutResponse<UserResponse>>(environment.coreApiUrl + 'users/profile-image', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  usm_usr_21(payload: any, raiseErrorToast: boolean = true): Observable<GetResponse<UserOptionsResponse>> {
    return this.get(environment.coreApiUrl + 'users/options', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_18(payload: USM_USR_18, raiseErrorToast: boolean = true): Observable<PostResponse<null>> {
    return this.post(environment.coreApiUrl + 'users/reset-password', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_19(payload: USM_USR_19, raiseErrorToast: boolean = true): Observable<LoginResponse> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/register/invitation-token', payload, options)
  }

  usm_usr_22(payload: USM_USR_22, raiseErrorToast: boolean = true): Observable<PutResponse<UserOptionsResponse>> {
    return this.put(environment.coreApiUrl + 'users/options', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_25(payload: USM_USR_25, raiseErrorToast: boolean = true): Observable<PostResponse<InvitationTokenVerificationResponse>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/register/invitation-token/verify', payload, options)
  }

  usm_usr_34(payload: USM_USR_34, raiseErrorToast: boolean = true): Observable<PostResponse<UserResponse>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/register/public', payload, options)
  }

  usm_usr_35(payload: USM_USR_35, raiseErrorToast: boolean = true): Observable<LoginResponse> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/verify-email', payload, options)
  }

  usm_usr_36(raiseErrorToast: boolean = true): Observable<GetResponse<CompanyResponse>> {
    return this.get(environment.coreApiUrl + 'users/personal-company', undefined, {raiseErrorToast: raiseErrorToast})
  }

  usm_ent_0(payload: USM_ENT_0, raiseErrorToast: boolean = true): Observable<GetResponse<UserEntityRelationWithoutUserDataResponse[]>> {
    return this.get(environment.coreApiUrl + 'users/access', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_ent_2(payload: USM_ENT_2, raiseErrorToast: boolean = true): Observable<PutResponse<UserEntityRelationWithUserDataResponse>> {
    return this.patch(environment.coreApiUrl + 'users/access', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_ent_3(payload: USM_ENT_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'users/access', payload, {raiseErrorToast: raiseErrorToast})
  }
  // usm_usr_2(payload: USM_USR_2, raiseErrorToast: boolean = true): Observable<PostResponse<UserResponse>> {
  //   return this.post(environment.coreApiUrl + 'users/', payload, {raiseErrorToast: raiseErrorToast})
  // }
  //
  // usm_usr_3(raiseErrorToast: boolean = true): Observable<PostResponse<UserResponse>>  {
  //   return this.get(environment.coreApiUrl + 'users/', undefined, {raiseErrorToast: raiseErrorToast})
  // }


  cor_coy_0(payload: COR_COY_0, raiseErrorToast: boolean = true): Observable<GetResponse<CompanyResponse>> {
    return this.get(environment.coreApiUrl + 'companies/', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_1(payload: COR_COY_1, raiseErrorToast: boolean = true): Observable<PostResponse<CompanyResponse>> {
    return this.post(environment.coreApiUrl + 'companies/', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_2(payload: COR_COY_2, raiseErrorToast: boolean = true): Observable<PutResponse<CompanyResponse>> {
    return this.put(environment.coreApiUrl + 'companies/', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_3(payload: COR_COY_3, raiseErrorToast: boolean = true): Observable<GetResponse<UserEntityRelationWithUserDataResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/employees', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_4(payload: COR_COY_4, raiseErrorToast: boolean = true): Observable<PaginationResponse<CompanyResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/all', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_5(payload: COR_COY_5, raiseErrorToast: boolean = true): Observable<GetResponse<CompanyImageResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/images', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_6(payload: COR_COY_6, raiseErrorToast: boolean = true): Observable<PostResponse<CompanyImageResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id

        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)

        // FormData instance
        let formData = new FormData();
        formData.append('image', payload.image);
        formData.append('company_id', payload.company_id);

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.post<PostResponse<CompanyImageResponse>>(environment.coreApiUrl + 'companies/images', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  cor_coy_7(payload: COR_COY_7, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'companies/images', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_8(payload: COR_COY_8, raiseErrorToast: boolean = true): Observable<PutResponse<CompanyResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id
        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)
          .set('image_type', payload.image_type);

        // FormData instance
        let formData = new FormData();
        formData.append('company_id', payload.company_id);
        formData.append('image', payload.image);
        formData.append('image_type', payload.image_type);

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<CompanyResponse>>(environment.coreApiUrl + 'companies/files', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  aqh_hor_0(payload: AQH_HOR_0, raiseErrorToast: boolean = true): Observable<GetResponse<HorseResponse[]>> {
    return this.get(environment.coreApiUrl + 'horses/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_hor_1(payload: AQH_HOR_1, raiseErrorToast: boolean = true): Observable<PostResponse<HorseResponse>> {
    return this.post(environment.coreApiUrl + 'horses/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_hor_2(payload: AQH_HOR_2, raiseErrorToast: boolean = true): Observable<PutResponse<HorseResponse>> {
    return this.put(environment.coreApiUrl + 'horses/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_hor_3(payload: AQH_HOR_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'horses/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_hor_4(payload: AQH_HOR_4, raiseErrorToast: boolean = true): Observable<PutResponse<HorseResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id

        let httpParams = new HttpParams()
          .set('horse_id', payload.horse_id.toString())
          .set('image_type', payload.image_type);

        // FormData instance
        let formData = new FormData();
        formData.append('image', payload.image);
        formData.append('image_type', payload.image_type);
        formData.append('horse_id', payload.horse_id.toString());

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<HorseResponse>>(environment.coreApiUrl + 'horses/images', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Search horses by name or passport ID
  aqh_hor_5(payload: AQH_HOR_5, raiseErrorToast: boolean = true): Observable<GetResponse<HorseResponse[]>> {
    return this.get(environment.coreApiUrl + 'horses/search', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Link an existing horse to current user
  aqh_hor_6(payload: AQH_HOR_6, raiseErrorToast: boolean = true): Observable<PostResponse<HorseResponse>> {
    return this.post(environment.coreApiUrl + 'horses/link', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_0(payload: AQH_MEM_0, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipResponse[]>> {
    return this.get(environment.coreApiUrl + 'memberships/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_1(payload: AQH_MEM_1, raiseErrorToast: boolean = true): Observable<PostResponse<MembershipResponse>> {
    return this.post(environment.coreApiUrl + 'memberships/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_2(payload: AQH_MEM_2, raiseErrorToast: boolean = true): Observable<PutResponse<MembershipResponse>> {
    return this.put(environment.coreApiUrl + 'memberships/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_3(payload: AQH_MEM_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'memberships/', payload, {raiseErrorToast: raiseErrorToast, useBody: true})
  }

  aqh_mem_4(payload: AQH_MEM_4, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipPlanResponse[]>> {
    return this.get(environment.coreApiUrl + 'memberships/plans', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_5(payload: AQH_MEM_5, raiseErrorToast: boolean = true): Observable<PostResponse<MembershipPlanResponse>> {
    return this.post(environment.coreApiUrl + 'memberships/plans', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_6(payload: AQH_MEM_6, raiseErrorToast: boolean = true): Observable<PutResponse<MembershipPlanResponse>> {
    return this.put(environment.coreApiUrl + 'memberships/plans', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_7(payload: AQH_MEM_7, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'memberships/plans', payload, {raiseErrorToast: raiseErrorToast, useBody: true})
  }

  // List all members for a company's membership plans (admin view) - AQH-MEM-8
  aqh_mem_8(payload: AQH_MEM_8, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipResponse[]>> {
    return this.get(environment.coreApiUrl + 'memberships/members', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Add member to plan (existing user or manual) - AQH-MEM-9
  aqh_mem_9(payload: AQH_MEM_9, raiseErrorToast: boolean = true): Observable<PostResponse<MembershipResponse>> {
    return this.post(environment.coreApiUrl + 'memberships/members', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Update member details - AQH-MEM-10
  aqh_mem_10(payload: AQH_MEM_10, raiseErrorToast: boolean = true): Observable<PutResponse<MembershipResponse>> {
    return this.put(environment.coreApiUrl + 'memberships/members', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Public endpoint for membership plans (no auth required) - AQH-MEM-11
  aqh_mem_11(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipPlanResponse[]>> {
    return this.get(environment.coreApiUrl + `memberships/plans/public/${company_id}`, {}, {raiseErrorToast: raiseErrorToast, auth: false})
  }

  aqh_fam_0(payload: AQH_FAM_0, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'families/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_fam_1(payload: AQH_FAM_1, raiseErrorToast: boolean = true): Observable<PostResponse<FamilyMemberResponse>> {
    return this.post(environment.coreApiUrl + 'families/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_fam_2(payload: AQH_FAM_2, raiseErrorToast: boolean = true): Observable<PostResponse<FamilyMemberResponse>> {
    return this.post(environment.coreApiUrl + 'families/child', payload, {raiseErrorToast: raiseErrorToast})
  }


  aqh_eve_0(payload: AQH_EVE_0, raiseErrorToast: boolean = true): Observable<PaginationResponse<EventResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_1(payload: AQH_EVE_1, raiseErrorToast: boolean = true): Observable<PostResponse<EventResponse>> {
    return this.post(environment.coreApiUrl + 'events/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_2(payload: AQH_EVE_2, raiseErrorToast: boolean = true): Observable<PutResponse<EventResponse>> {
    return this.put(environment.coreApiUrl + 'events/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_3(payload: AQH_EVE_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_4(payload: AQH_EVE_4, raiseErrorToast: boolean = true): Observable<GetResponse<EventTypeResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/event-types', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_5(payload: AQH_EVE_5, raiseErrorToast: boolean = true): Observable<PutResponse<EventResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id

        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)
          .set('event_id', payload.event_id.toString())
          .set('image_type', payload.image_type);

        // FormData instance
        let formData = new FormData();
        formData.append('company_id', payload.company_id);
        formData.append('image', payload.image);
        formData.append('image_type', payload.image_type);
        formData.append('event_id', payload.event_id.toString());

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<EventResponse>>(environment.coreApiUrl + 'events/files', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  aqh_eve_6(payload: AQH_EVE_6, raiseErrorToast: boolean = true): Observable<GetResponse<EventClassResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/event-classes', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_7(payload: AQH_EVE_7, raiseErrorToast: boolean = true): Observable<PostResponse<EventClassResponse>> {
    return this.post(environment.coreApiUrl + 'events/event-classes', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_8(payload: AQH_EVE_8, raiseErrorToast: boolean = true): Observable<PutResponse<EventClassResponse>> {
    return this.put(environment.coreApiUrl + 'events/event-classes', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_9(payload: AQH_EVE_9, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/event-classes', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_10(payload: AQH_EVE_10, raiseErrorToast: boolean = true): Observable<PutResponse<EventClassResponse>> {
    return this.put(environment.coreApiUrl + 'events/event-classes/status', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_11(payload: AQH_EVE_11, raiseErrorToast: boolean = true): Observable<GetResponse<EventServiceResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/event-services', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_12(payload: AQH_EVE_12, raiseErrorToast: boolean = true): Observable<PostResponse<EventServiceResponse>> {
    return this.post(environment.coreApiUrl + 'events/event-services', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_13(payload: AQH_EVE_13, raiseErrorToast: boolean = true): Observable<PutResponse<EventServiceResponse>> {
    return this.put(environment.coreApiUrl + 'events/event-services', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_14(payload: AQH_EVE_14, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/event-services', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_15(payload: AQH_EVE_15, raiseErrorToast: boolean = true): Observable<PostResponse<SponsorResponse>> {
    return this.post(environment.coreApiUrl + 'events/sponsors', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_16(payload: AQH_EVE_16, raiseErrorToast: boolean = true): Observable<PostResponse<EventSponsorResponse>> {
    return this.post(environment.coreApiUrl + 'events/sponsors/event', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_17(payload: AQH_EVE_17, raiseErrorToast: boolean = true): Observable<PostResponse<EventClassSponsorResponse>> {
    return this.post(environment.coreApiUrl + 'events/sponsors/event-class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_18(payload: AQH_EVE_18, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/sponsors/event', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_19(payload: AQH_EVE_19, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/sponsors/event-class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_20(payload: AQH_EVE_20, raiseErrorToast: boolean = true): Observable<PutResponse<SponsorResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('sponsor_id', payload.sponsor_id.toString())
          .set('image_type', payload.image_type);

        let formData = new FormData();
        formData.append('sponsor_id', payload.sponsor_id.toString());
        formData.append('image', payload.image);
        formData.append('image_type', payload.image_type);

        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<SponsorResponse>>(environment.coreApiUrl + 'events/sponsors/files', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  aqh_eve_21(payload: AQH_EVE_21, raiseErrorToast: boolean = true): Observable<GetResponse<EventSponsorResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/sponsors/event', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_22(payload: AQH_EVE_22, raiseErrorToast: boolean = true): Observable<GetResponse<EventClassSponsorResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/sponsors/event-class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_23(payload: AQH_EVE_23, raiseErrorToast: boolean = true): Observable<PutResponse<SponsorResponse>> {
    return this.put(environment.coreApiUrl + 'events/sponsors', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_24(payload: AQH_EVE_24, raiseErrorToast: boolean = true): Observable<GetResponse<EventContactResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/contacts', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_25(payload: AQH_EVE_25, raiseErrorToast: boolean = true): Observable<PostResponse<EventContactResponse>> {
    return this.post(environment.coreApiUrl + 'events/contacts', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_26(payload: AQH_EVE_26, raiseErrorToast: boolean = true): Observable<PutResponse<EventContactResponse>> {
    return this.put(environment.coreApiUrl + 'events/contacts', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_27(payload: AQH_EVE_27, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/contacts', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_28(payload: AQH_EVE_28, raiseErrorToast: boolean = true): Observable<GetResponse<EventContactRoleResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/contact-roles', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_29(payload: AQH_EVE_29, raiseErrorToast: boolean = true): Observable<PostResponse<EventClassRegistrationResponse>> {
    return this.post(environment.coreApiUrl + 'events/registrations/class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_30(payload: AQH_EVE_30, raiseErrorToast: boolean = true): Observable<PostResponse<EventServiceRegistrationResponse>> {
    return this.post(environment.coreApiUrl + 'events/registrations/service', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_31(payload: AQH_EVE_31, raiseErrorToast: boolean = true): Observable<GetResponse<{class_registrations: EventClassRegistrationResponse[], service_registrations: EventServiceRegistrationResponse[]}>> {
    return this.get(environment.coreApiUrl + 'events/registrations', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_32(payload: AQH_EVE_32, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/registrations/class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_33(payload: AQH_EVE_33, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/registrations/service', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_34(payload: AQH_EVE_34, raiseErrorToast: boolean = true): Observable<PutResponse<any>> {
    return this.put(environment.coreApiUrl + 'events/registrations/class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_35(payload: AQH_EVE_35, raiseErrorToast: boolean = true): Observable<PutResponse<any>> {
    return this.put(environment.coreApiUrl + 'events/registrations/service', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_36(payload: AQH_EVE_36, raiseErrorToast: boolean = true): Observable<PostResponse<any>> {
    return this.post(environment.coreApiUrl + 'events/registrations/class/admin', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_37(payload: AQH_EVE_37, raiseErrorToast: boolean = true): Observable<PostResponse<any>> {
    return this.post(environment.coreApiUrl + 'events/registrations/service/admin', payload, {raiseErrorToast: raiseErrorToast})
  }


  aqh_cls_0(payload: AQH_CLS_0, raiseErrorToast: boolean = true): Observable<GetResponse<ClassResponse[]>> {
    return this.get(environment.coreApiUrl + 'classes/', payload, {raiseErrorToast: raiseErrorToast})
  }



  aqg_cls_0(payload: AQH_CLS_0, raiseErrorToast: boolean = true): Observable<GetResponse<ClassResponse[]>> {
    return this.get(environment.coreApiUrl + 'classes/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_sta_0(payload: AQH_STA_0, raiseErrorToast: boolean = true): Observable<GetResponse<HorseRegistryResponse[]>> {
    return this.get(environment.coreApiUrl + 'static/horse-registries', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_sta_1(payload: AQH_STA_1, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipPlanResponse[]>> {
    return this.get(environment.coreApiUrl + 'static/membership-plans', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_sta_2(payload: AQH_STA_2, raiseErrorToast: boolean = true): Observable<GetResponse<CountryResponse[]>> {
    return this.get(environment.coreApiUrl + 'static/countries', payload, {auth: false, raiseErrorToast: raiseErrorToast})
  }

  // Schedule endpoints
  aqh_eve_40(payload: AQH_EVE_40, raiseErrorToast: boolean = true): Observable<GetResponse<EventScheduleResponse>> {
    return this.get(environment.coreApiUrl + 'events/schedules', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_41(payload: AQH_EVE_41, raiseErrorToast: boolean = true): Observable<PostResponse<EventScheduleResponse>> {
    return this.post(environment.coreApiUrl + 'events/schedules', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_42(payload: AQH_EVE_42, raiseErrorToast: boolean = true): Observable<PutResponse<EventScheduleResponse>> {
    return this.put(environment.coreApiUrl + 'events/schedules', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_43(payload: AQH_EVE_43, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/schedules', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_44(payload: AQH_EVE_44, raiseErrorToast: boolean = true): Observable<GetResponse<EventScheduleEntryResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/schedules/entries', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_45(payload: AQH_EVE_45, raiseErrorToast: boolean = true): Observable<PutResponse<EventScheduleEntryResponse[]>> {
    return this.put(environment.coreApiUrl + 'events/schedules/entries/reorder', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_46(payload: AQH_EVE_46, raiseErrorToast: boolean = true): Observable<PostResponse<EventScheduleEntryResponse>> {
    return this.post(environment.coreApiUrl + 'events/schedules/entries', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_47(payload: AQH_EVE_47, raiseErrorToast: boolean = true): Observable<PutResponse<EventScheduleEntryResponse>> {
    return this.put(environment.coreApiUrl + 'events/schedules/entries', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_48(payload: AQH_EVE_48, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/schedules/entries', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_55(payload: AQH_EVE_55, raiseErrorToast: boolean = true): Observable<PutResponse<EventScheduleResponse>> {
    return this.put(environment.coreApiUrl + 'events/schedules/entries/batch', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_49(payload: AQH_EVE_49, raiseErrorToast: boolean = true): Observable<PostResponse<EventScheduleResponse>> {
    return this.post(environment.coreApiUrl + 'events/schedules/live/start', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_50(payload: AQH_EVE_50, raiseErrorToast: boolean = true): Observable<PostResponse<EventScheduleResponse>> {
    return this.post(environment.coreApiUrl + 'events/schedules/live/advance', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_51(payload: AQH_EVE_51, raiseErrorToast: boolean = true): Observable<PostResponse<EventScheduleResponse>> {
    return this.post(environment.coreApiUrl + 'events/schedules/live/previous', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_52(payload: AQH_EVE_52, raiseErrorToast: boolean = true): Observable<GetResponse<EventScheduleLiveStatusResponse>> {
    return this.get(environment.coreApiUrl + 'events/schedules/live/status', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_53(payload: AQH_EVE_53, raiseErrorToast: boolean = true): Observable<GetResponse<EventScheduleResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'events/schedules/public', payload, options)
  }

  // Announcement endpoints
  aqh_eve_60(payload: AQH_EVE_60, raiseErrorToast: boolean = true): Observable<PostResponse<EventAnnouncementResponse>> {
    return this.post(environment.coreApiUrl + 'events/announcements', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_61(payload: AQH_EVE_61, raiseErrorToast: boolean = true): Observable<PutResponse<EventAnnouncementResponse>> {
    return this.put(environment.coreApiUrl + 'events/announcements', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_62(payload: AQH_EVE_62, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/announcements', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_63(payload: AQH_EVE_63, raiseErrorToast: boolean = true): Observable<PostResponse<EventAnnouncementResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)
          .set('announcement_id', payload.announcement_id.toString());

        if (payload.position !== undefined) {
          httpParams = httpParams.set('position', payload.position.toString());
        }

        let formData = new FormData();
        formData.append('company_id', payload.company_id);
        formData.append('announcement_id', payload.announcement_id.toString());
        formData.append('image', payload.image);
        if (payload.position !== undefined) {
          formData.append('position', payload.position.toString());
        }

        const options = { headers: headers, params: httpParams };

        return this.http.post<PostResponse<EventAnnouncementResponse>>(environment.coreApiUrl + 'events/announcements/images', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  aqh_eve_64(payload: AQH_EVE_64, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/announcements/images', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_65(payload: AQH_EVE_65, raiseErrorToast: boolean = true): Observable<GetResponse<EventAnnouncementResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/announcements', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_66(payload: AQH_EVE_65, raiseErrorToast: boolean = true): Observable<GetResponse<EventAnnouncementResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'events/announcements/public', payload, options)
  }

  // Public results endpoint
  aqh_eve_140(payload: AQH_EVE_140, raiseErrorToast: boolean = true): Observable<GetResponse<PublicClassResultsResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'events/results/public', payload, options)
  }

  // User results endpoint
  aqh_eve_141(payload: AQH_EVE_141, raiseErrorToast: boolean = true): Observable<GetResponse<UserResultResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/results/user', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Result images endpoints
  aqh_eve_142(payload: AQH_EVE_142, raiseErrorToast: boolean = true): Observable<PostResponse<ResultImageResponse>> {
    const formData = new FormData();
    formData.append('result_id', payload.result_id.toString());
    formData.append('image', payload.image);
    if (payload.image_name) {
      formData.append('image_name', payload.image_name);
    }
    return this.postMultipart(environment.coreApiUrl + 'events/results/images', formData, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_143(payload: AQH_EVE_143, raiseErrorToast: boolean = true): Observable<GetResponse<ResultImageResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/results/images', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_144(payload: AQH_EVE_144, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/results/images', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Registration Payment Status endpoints
  aqh_eve_150(payload: AQH_EVE_150, raiseErrorToast: boolean = true): Observable<PutResponse<any>> {
    return this.put(environment.coreApiUrl + 'events/registrations/class/payment', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_151(payload: AQH_EVE_151, raiseErrorToast: boolean = true): Observable<PutResponse<any>> {
    return this.put(environment.coreApiUrl + 'events/registrations/service/payment', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_152(payload: AQH_EVE_152, raiseErrorToast: boolean = true): Observable<PutResponse<any>> {
    return this.put(environment.coreApiUrl + 'events/orders/payment', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Chat endpoints
  aqh_cht_1(payload: AQH_CHT_1, raiseErrorToast: boolean = true): Observable<PostResponse<ConversationResponse>> {
    return this.post(environment.coreApiUrl + 'chat/conversations', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_cht_2(payload: AQH_CHT_2, raiseErrorToast: boolean = true): Observable<PaginationResponse<ConversationResponse[]>> {
    return this.get(environment.coreApiUrl + 'chat/conversations', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_cht_3(payload: AQH_CHT_3, raiseErrorToast: boolean = true): Observable<PostResponse<MessageResponse>> {
    return this.post(environment.coreApiUrl + 'chat/messages', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_cht_4(payload: AQH_CHT_4, raiseErrorToast: boolean = true): Observable<PaginationResponse<MessageResponse[]>> {
    return this.get(environment.coreApiUrl + `chat/conversations/${payload.conversation_id}/messages`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_cht_5(payload: AQH_CHT_5, raiseErrorToast: boolean = true): Observable<PostResponse<any>> {
    return this.post(environment.coreApiUrl + `chat/conversations/${payload.conversation_id}/read`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_cht_6(payload: AQH_CHT_6, raiseErrorToast: boolean = true): Observable<GetResponse<UnreadCountResponse>> {
    return this.get(environment.coreApiUrl + 'chat/unread-count', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_cht_7(payload: AQH_CHT_7, raiseErrorToast: boolean = true): Observable<GetResponse<ConversationResponse>> {
    return this.get(environment.coreApiUrl + `chat/conversations/${payload.conversation_id}`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // User search for contacts
  aqh_eve_67(payload: AQH_EVE_67, raiseErrorToast: boolean = true): Observable<GetResponse<UserSearchResult[]>> {
    return this.get(environment.coreApiUrl + 'events/users/search', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Event Tracks
  aqh_eve_68(event_id: number, raiseErrorToast: boolean = true): Observable<GetResponse<EventTrackResponse[]>> {
    return this.get(environment.coreApiUrl + `events/${event_id}/tracks`, {}, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_69(event_id: number, payload: Omit<AQH_EVE_69, 'event_id'>, raiseErrorToast: boolean = true): Observable<GetResponse<EventTrackResponse>> {
    return this.post(environment.coreApiUrl + `events/${event_id}/tracks`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_70(payload: AQH_EVE_70, raiseErrorToast: boolean = true): Observable<GetResponse<EventTrackResponse>> {
    return this.put(environment.coreApiUrl + `events/tracks/${payload.track_id}`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_71(track_id: number, raiseErrorToast: boolean = true): Observable<GetResponse<{deleted: boolean}>> {
    return this.delete(environment.coreApiUrl + `events/tracks/${track_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Event Publish
  aqh_eve_72(event_id: number, payload: { company_id: string; status: 'draft' | 'published' }, raiseErrorToast: boolean = true): Observable<GetResponse<EventResponse>> {
    return this.put(environment.coreApiUrl + `events/${event_id}/publish`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Schedule Groups
  aqh_eve_73(payload: AQH_EVE_73, raiseErrorToast: boolean = true): Observable<GetResponse<EventScheduleGroupResponse>> {
    return this.post(environment.coreApiUrl + `events/schedules/groups`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_74(payload: AQH_EVE_74, raiseErrorToast: boolean = true): Observable<GetResponse<EventScheduleGroupResponse>> {
    return this.put(environment.coreApiUrl + `events/schedules/groups`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_75(payload: AQH_EVE_75, raiseErrorToast: boolean = true): Observable<GetResponse<{deleted: boolean}>> {
    return this.delete(environment.coreApiUrl + `events/schedules/groups`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_76(payload: AQH_EVE_76, raiseErrorToast: boolean = true): Observable<GetResponse<EventScheduleGroupResponse[]>> {
    return this.get(environment.coreApiUrl + `events/schedules/groups`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Day Breaks
  aqh_eve_77(event_id: number, payload: Omit<AQH_EVE_77, 'event_id'> = {}, raiseErrorToast: boolean = true): Observable<GetResponse<DayBreakResponse[]>> {
    return this.get(environment.coreApiUrl + `events/${event_id}/day-breaks`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_78(event_id: number, payload: Omit<AQH_EVE_78, 'event_id'>, raiseErrorToast: boolean = true): Observable<GetResponse<DayBreakResponse>> {
    return this.post(environment.coreApiUrl + `events/${event_id}/day-breaks`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_79(payload: AQH_EVE_79, raiseErrorToast: boolean = true): Observable<GetResponse<DayBreakResponse>> {
    return this.put(environment.coreApiUrl + `events/day-breaks/${payload.day_break_id}`, payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_80(day_break_id: number, raiseErrorToast: boolean = true): Observable<GetResponse<{deleted: boolean}>> {
    return this.delete(environment.coreApiUrl + `events/day-breaks/${day_break_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== EVENT EXPENSES ====================

  // Create event expense - AQH-EVE-90
  aqh_eve_90(payload: AQH_EVE_90, raiseErrorToast: boolean = true): Observable<PostResponse<EventExpenseResponse>> {
    return this.post(environment.coreApiUrl + 'events/expenses', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Update event expense - AQH-EVE-91
  aqh_eve_91(payload: AQH_EVE_91, raiseErrorToast: boolean = true): Observable<PutResponse<EventExpenseResponse>> {
    return this.put(environment.coreApiUrl + 'events/expenses', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete event expense - AQH-EVE-92
  aqh_eve_92(payload: AQH_EVE_92, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/expenses', payload, {raiseErrorToast: raiseErrorToast, useBody: true})
  }

  // Get event expenses - AQH-EVE-93
  aqh_eve_93(payload: AQH_EVE_93, raiseErrorToast: boolean = true): Observable<GetResponse<EventExpenseResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/expenses', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Upload expense image - AQH-EVE-94
  aqh_eve_94(payload: AQH_EVE_94, raiseErrorToast: boolean = true): Observable<PostResponse<EventExpenseImageResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)
          .set('expense_id', payload.expense_id.toString())
          .set('position', (payload.position ?? 0).toString());

        let formData = new FormData();
        formData.append('company_id', payload.company_id);
        formData.append('expense_id', payload.expense_id.toString());
        formData.append('image', payload.image);
        formData.append('position', (payload.position ?? 0).toString());

        const options = { headers: headers, params: httpParams };

        return this.http.post<PostResponse<EventExpenseImageResponse>>(environment.coreApiUrl + 'events/expenses/images', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // ==================== PUBLIC ENDPOINTS (No Auth Required) ====================

  // Public events list - AQH-EVE-81
  aqh_eve_81(payload: AQH_EVE_0, raiseErrorToast: boolean = true): Observable<PaginationResponse<EventResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'events/public', payload, options)
  }

  // Public single event - AQH-EVE-82
  aqh_eve_82(event_id: number, raiseErrorToast: boolean = true): Observable<PaginationResponse<EventResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `events/public/${event_id}`, {}, options)
  }

  // Public event types - AQH-EVE-83
  aqh_eve_83(raiseErrorToast: boolean = true): Observable<GetResponse<EventTypeResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'events/event-types/public', {}, options)
  }

  // Public companies list - COR-COY-10
  cor_coy_10(payload: COR_COY_4, raiseErrorToast: boolean = true): Observable<PaginationResponse<CompanyResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'companies/public', payload, options)
  }

  // Public single company - COR-COY-11
  cor_coy_11(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<CompanyResponse>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `companies/public/${company_id}`, {}, options)
  }

  // Public company employees - COR-COY-12
  cor_coy_12(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<UserEntityRelationWithUserDataResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `companies/public/${company_id}/employees`, {}, options)
  }

  // ==================== COMPANY SPONSOR ENDPOINTS ====================

  // Get company sponsors - COR-COY-20
  cor_coy_20(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<CompanySponsorResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/sponsors', { company_id }, {raiseErrorToast: raiseErrorToast})
  }

  // Add sponsor to company - COR-COY-21
  cor_coy_21(payload: { company_id: string; sponsor_name: string; sponsor_description?: string }, raiseErrorToast: boolean = true): Observable<PostResponse<CompanySponsorResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)
          .set('sponsor_name', payload.sponsor_name);

        if (payload.sponsor_description) {
          httpParams = httpParams.set('sponsor_description', payload.sponsor_description);
        }

        const options = { headers: headers, params: httpParams };

        return this.http.post<PostResponse<CompanySponsorResponse>>(environment.coreApiUrl + 'companies/sponsors', {}, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Update company sponsor - COR-COY-22
  cor_coy_22(entry_id: number, payload: { company_id: string; sponsor_name?: string; sponsor_description?: string }, raiseErrorToast: boolean = true): Observable<PutResponse<CompanySponsorResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams().set('company_id', payload.company_id);
        if (payload.sponsor_name) httpParams = httpParams.set('sponsor_name', payload.sponsor_name);
        if (payload.sponsor_description !== undefined) httpParams = httpParams.set('sponsor_description', payload.sponsor_description);

        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<CompanySponsorResponse>>(environment.coreApiUrl + `companies/sponsors/${entry_id}`, {}, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Delete company sponsor - COR-COY-23
  cor_coy_23(entry_id: number, company_id: string, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + `companies/sponsors/${entry_id}`, { company_id }, {raiseErrorToast: raiseErrorToast})
  }

  // Reorder company sponsors - COR-COY-24
  cor_coy_24(company_id: string, entry_ids: number[], raiseErrorToast: boolean = true): Observable<PutResponse<{ message: string }>> {
    return this.put(environment.coreApiUrl + 'companies/sponsors/reorder', { company_id, entry_ids }, {raiseErrorToast: raiseErrorToast})
  }

  // Upload sponsor logo - COR-COY-25
  cor_coy_25(entry_id: number, company_id: string, logo: File, raiseErrorToast: boolean = true): Observable<PutResponse<CompanySponsorResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams().set('company_id', company_id);

        let formData = new FormData();
        formData.append('company_id', company_id);
        formData.append('logo', logo);

        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<CompanySponsorResponse>>(environment.coreApiUrl + `companies/sponsors/${entry_id}/logo`, formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Get company sponsors (public) - COR-COY-26
  cor_coy_26(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<CompanySponsorResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `companies/public/${company_id}/sponsors`, {}, options)
  }

  // Get company documents - COR-COY-27
  cor_coy_27(payload: COR_COY_27, raiseErrorToast: boolean = true): Observable<GetResponse<CompanyDocumentResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/documents', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Upload company document - COR-COY-28
  cor_coy_28(payload: COR_COY_28, raiseErrorToast: boolean = true): Observable<PostResponse<CompanyDocumentResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams().set('company_id', payload.company_id);
        if (payload.document_name) {
          httpParams = httpParams.set('document_name', payload.document_name);
        }
        if (payload.document_type) {
          httpParams = httpParams.set('document_type', payload.document_type);
        }
        if (payload.description) {
          httpParams = httpParams.set('description', payload.description);
        }

        let formData = new FormData();
        formData.append('document', payload.document);

        // Remove Content-Type to let browser set boundary
        const uploadHeaders = headers.delete('Content-Type');
        const options = { headers: uploadHeaders, params: httpParams };

        return this.http.post<PostResponse<CompanyDocumentResponse>>(environment.coreApiUrl + 'companies/documents', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Update company document - COR-COY-29
  cor_coy_29(document_id: number, payload: { company_id: string; document_name?: string; document_type?: string; description?: string }, raiseErrorToast: boolean = true): Observable<PutResponse<CompanyDocumentResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams().set('company_id', payload.company_id);
        if (payload.document_name) {
          httpParams = httpParams.set('document_name', payload.document_name);
        }
        if (payload.document_type) {
          httpParams = httpParams.set('document_type', payload.document_type);
        }
        if (payload.description !== undefined) {
          httpParams = httpParams.set('description', payload.description || '');
        }

        const options = { headers: headers, params: httpParams };
        return this.http.put<PutResponse<CompanyDocumentResponse>>(environment.coreApiUrl + `companies/documents/${document_id}`, {}, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Delete company document - COR-COY-30
  cor_coy_30(document_id: number, payload: COR_COY_30, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams().set('company_id', payload.company_id);
        const options = { headers: headers, params: httpParams };
        return this.http.delete<DeleteResponse>(environment.coreApiUrl + `companies/documents/${document_id}`, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Get company documents (public) - COR-COY-31
  cor_coy_31(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<CompanyDocumentResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `companies/public/${company_id}/documents`, {}, options)
  }

  // Get company categories for stores_services type - COR-COY-32
  cor_coy_32(raiseErrorToast: boolean = true): Observable<GetResponse<CompanyCategoryResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'companies/categories', {}, options)
  }

  // Soft delete company - COR-COY-40
  cor_coy_40(payload: COR_COY_40, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'companies/', payload, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== MARKET DEALS ENDPOINTS ====================

  // Get company market deals (admin) - COR-COY-50
  cor_coy_50(payload: COR_COY_50, raiseErrorToast: boolean = true): Observable<GetResponse<MarketDealResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/deals', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Create market deal - COR-COY-51
  cor_coy_51(payload: COR_COY_51, raiseErrorToast: boolean = true): Observable<PostResponse<MarketDealResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)
          .set('title', payload.title)
          .set('start_date', payload.start_date)
          .set('end_date', payload.end_date)
          .set('discount_code', payload.discount_code);

        if (payload.description) {
          httpParams = httpParams.set('description', payload.description);
        }
        if (payload.discount_percentage !== undefined && payload.discount_percentage !== null) {
          httpParams = httpParams.set('discount_percentage', payload.discount_percentage.toString());
        }

        const options = { headers: headers, params: httpParams };

        return this.http.post<PostResponse<MarketDealResponse>>(environment.coreApiUrl + 'companies/deals', {}, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Update market deal - COR-COY-52
  cor_coy_52(deal_id: number, payload: COR_COY_52, raiseErrorToast: boolean = true): Observable<PutResponse<MarketDealResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('company_id', payload.company_id);

        if (payload.title) {
          httpParams = httpParams.set('title', payload.title);
        }
        if (payload.description !== undefined) {
          httpParams = httpParams.set('description', payload.description);
        }
        if (payload.start_date) {
          httpParams = httpParams.set('start_date', payload.start_date);
        }
        if (payload.end_date) {
          httpParams = httpParams.set('end_date', payload.end_date);
        }
        if (payload.discount_code) {
          httpParams = httpParams.set('discount_code', payload.discount_code);
        }
        if (payload.discount_percentage !== undefined && payload.discount_percentage !== null) {
          httpParams = httpParams.set('discount_percentage', payload.discount_percentage.toString());
        }
        if (payload.is_active !== undefined) {
          httpParams = httpParams.set('is_active', payload.is_active.toString());
        }

        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<MarketDealResponse>>(environment.coreApiUrl + `companies/deals/${deal_id}`, {}, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Delete market deal - COR-COY-53
  cor_coy_53(deal_id: number, payload: COR_COY_53, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('company_id', payload.company_id);

        const options = { headers: headers, params: httpParams };

        return this.http.delete<DeleteResponse>(environment.coreApiUrl + `companies/deals/${deal_id}`, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Upload deal image - COR-COY-54
  cor_coy_54(deal_id: number, company_id: string, image: File, raiseErrorToast: boolean = true): Observable<PutResponse<MarketDealResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('company_id', company_id);

        const formData = new FormData();
        formData.append('image', image);

        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<MarketDealResponse>>(environment.coreApiUrl + `companies/deals/${deal_id}/image`, formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Get public company deals - COR-COY-55
  cor_coy_55(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<MarketDealResponse[]>> {
    // Send auth header if user has a token (optional auth - show discount code for logged in users)
    const hasToken = this.jwtService.getAccessToken() != null && this.jwtService.getAccessToken() != '';
    let options: EndpointOptions = {
      auth: hasToken,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `companies/public/${company_id}/deals`, {}, options)
  }

  // Get all active deals (Hot Deals) - COR-COY-56
  cor_coy_56(raiseErrorToast: boolean = true): Observable<GetResponse<MarketDealResponse[]>> {
    // Send auth header if user has a token (optional auth - show discount code for logged in users)
    const hasToken = this.jwtService.getAccessToken() != null && this.jwtService.getAccessToken() != '';
    let options: EndpointOptions = {
      auth: hasToken,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'companies/public/deals/active', {}, options)
  }

  // Public event classes - AQH-EVE-84
  aqh_eve_84(event_id: number, raiseErrorToast: boolean = true): Observable<GetResponse<EventClassResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `events/public/${event_id}/classes`, {}, options)
  }

  // Public event services - AQH-EVE-85
  aqh_eve_85(event_id: number, raiseErrorToast: boolean = true): Observable<GetResponse<EventServiceResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `events/public/${event_id}/services`, {}, options)
  }

  // Public event sponsors - AQH-EVE-86
  aqh_eve_86(event_id: number, raiseErrorToast: boolean = true): Observable<GetResponse<EventSponsorResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `events/public/${event_id}/sponsors`, {}, options)
  }

  // Public event contacts - AQH-EVE-87
  aqh_eve_87(event_id: number, raiseErrorToast: boolean = true): Observable<GetResponse<EventContactResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `events/public/${event_id}/contacts`, {}, options)
  }

  // ==================== PAYMENT ENDPOINTS ====================

  // Stripe Connect - Create account and start onboarding
  aqh_pay_1(payload: { company_id: string; business_type?: 'individual' | 'company'; accept_fee_terms?: boolean }, raiseErrorToast: boolean = true): Observable<PostResponse<{ onboarding_url: string; account_id: string }>> {
    return this.post(environment.coreApiUrl + 'payments/stripe/connect/onboard', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Stripe Connect - Get account status
  aqh_pay_2(payload: { company_id: string }, raiseErrorToast: boolean = true): Observable<GetResponse<StripeConnectStatus>> {
    return this.get(environment.coreApiUrl + 'payments/stripe/connect/status', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Stripe Connect - Refresh onboarding link
  aqh_pay_3(payload: { company_id: string }, raiseErrorToast: boolean = true): Observable<PostResponse<{ onboarding_url: string }>> {
    return this.post(environment.coreApiUrl + 'payments/stripe/connect/refresh', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Stripe Connect - Get dashboard link
  aqh_pay_4(payload: { company_id: string }, raiseErrorToast: boolean = true): Observable<GetResponse<{ dashboard_url: string }>> {
    return this.get(environment.coreApiUrl + 'payments/stripe/connect/dashboard', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Create Stripe Checkout session
  aqh_pay_5(payload: {
    event_id: number;
    class_registrations: Array<{ event_class_id: number; user_id: string; horse_id: number }>;
    service_registrations: Array<{ event_service_id: number; user_id: string; num_registrations: number }>;
  }, raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string; order_id: number; free_order?: boolean }>> {
    return this.post(environment.coreApiUrl + 'payments/checkout/create', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get orders
  aqh_pay_6(payload: { user_id?: string; event_id?: number }, raiseErrorToast: boolean = true): Observable<GetResponse<OrderResponse[]>> {
    return this.get(environment.coreApiUrl + 'payments/orders', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get specific order
  aqh_pay_7(order_id: number, raiseErrorToast: boolean = true): Observable<GetResponse<OrderResponse>> {
    return this.get(environment.coreApiUrl + `payments/orders/${order_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Pay-later registration
  aqh_pay_12(payload: {
    event_id: number;
    class_registrations: Array<{ event_class_id: number; user_id: string; horse_id: number }>;
    service_registrations: Array<{ event_service_id: number; user_id: string; num_registrations: number }>;
  }, raiseErrorToast: boolean = true): Observable<PostResponse<{ order_id: number; status: string; message: string }>> {
    return this.post(environment.coreApiUrl + 'payments/register/pay-later', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Pay pending order
  aqh_pay_10(payload: { order_id: number }, raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string; order_id: number }>> {
    return this.post(environment.coreApiUrl + 'payments/orders/pay', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Cancel pending order
  aqh_pay_11(payload: { order_id: number }, raiseErrorToast: boolean = true): Observable<PostResponse<{ order_id: number; status: string; message: string }>> {
    return this.post(environment.coreApiUrl + 'payments/orders/cancel', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Membership checkout
  aqh_pay_13(payload: { plan_id: number; success_url?: string; cancel_url?: string }, raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string; order_id: number; membership_id: number }>> {
    return this.post(environment.coreApiUrl + 'payments/membership/checkout', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Training checkout session
  aqh_pay_14(payload: any, raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string; order_id: number; free_order?: boolean }>> {
    return this.post(environment.coreApiUrl + 'payments/training/checkout', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Training pay-later registration
  aqh_pay_15(payload: any, raiseErrorToast: boolean = true): Observable<PostResponse<{ order_id: number; status: string; message: string }>> {
    return this.post(environment.coreApiUrl + 'payments/training/pay-later', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Refund order - AQH-PAY-20
  aqh_pay_20(order_id: number, payload: any, raiseErrorToast: boolean = true): Observable<PostResponse<any>> {
    return this.post(environment.coreApiUrl + `payments/orders/${order_id}/refund`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Store registration checkout - AQH-PAY-21
  aqh_pay_21(payload: {
    company_name: string;
    company_type: string;
    category_id: number;
    organisation_number?: string;
    address?: string;
    city?: string;
    postal_code?: string;
    country?: string;
    country_id?: number;
    phone?: string;
    email?: string;
    description?: string;
  }, raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string; pending_registration_id: number }>> {
    return this.post(environment.coreApiUrl + 'payments/store/checkout', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Club Pro subscription checkout - AQH-PAY-22
  aqh_pay_22(payload: {
    company_id: string;
    success_url?: string;
    cancel_url?: string;
  }, raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string }>> {
    return this.post(environment.coreApiUrl + 'payments/club/pro/checkout', payload, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== FAVORITES ENDPOINTS ====================

  // Add organization to favorites - FAV-ORG-1
  fav_org_1(company_id: string, raiseErrorToast: boolean = true): Observable<PostResponse<{ message: string; is_favorite: boolean }>> {
    return this.post(environment.coreApiUrl + `favorites/organizations/${company_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Remove organization from favorites - FAV-ORG-2
  fav_org_2(company_id: string, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + `favorites/organizations/${company_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Check if organization is favorited - FAV-ORG-3
  fav_org_3(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<{ is_favorite: boolean }>> {
    return this.get(environment.coreApiUrl + `favorites/organizations/${company_id}/status`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Get user's favorite organizations - FAV-ORG-4
  fav_org_4(raiseErrorToast: boolean = true): Observable<GetResponse<{ favorites: any[] }>> {
    return this.get(environment.coreApiUrl + 'favorites/organizations', {}, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== FEED ENDPOINTS ====================

  // Get feed posts for a company - FEED-1
  feed_1(payload: FEED_1, raiseErrorToast: boolean = true): Observable<PaginationResponse<FeedPostResponse[]>> {
    return this.get(environment.coreApiUrl + `feed/company/${payload.company_id}`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get single feed post - FEED-2
  feed_2(feed_post_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<FeedPostResponse>> {
    return this.get(environment.coreApiUrl + `feed/post/${feed_post_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Create feed post - FEED-3
  feed_3(payload: FEED_3, raiseErrorToast: boolean = true): Observable<PostResponse<FeedPostResponse>> {
    return this.post(environment.coreApiUrl + `feed/company/${payload.company_id}`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Update feed post - FEED-4
  feed_4(payload: FEED_4, raiseErrorToast: boolean = true): Observable<PutResponse<FeedPostResponse>> {
    return this.put(environment.coreApiUrl + `feed/post/${payload.feed_post_id}`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete feed post - FEED-5
  feed_5(feed_post_id: string, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + `feed/post/${feed_post_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Add image to feed post - FEED-6
  feed_6(payload: FEED_6, raiseErrorToast: boolean = true): Observable<PostResponse<FeedPostImageResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('feed_post_id', payload.feed_post_id);

        let formData = new FormData();
        formData.append('feed_post_id', payload.feed_post_id);
        formData.append('image', payload.image);

        const options = { headers: headers, params: httpParams };

        return this.http.post<PostResponse<FeedPostImageResponse>>(environment.coreApiUrl + `feed/post/${payload.feed_post_id}/images`, formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Delete image from feed post - FEED-7
  feed_7(image_id: number, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + `feed/image/${image_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Reorder images in feed post - FEED-8
  feed_8(payload: FEED_8, raiseErrorToast: boolean = true): Observable<PutResponse<FeedPostResponse>> {
    return this.put(environment.coreApiUrl + `feed/post/${payload.feed_post_id}/images/reorder`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get public feed posts for a company (no auth) - FEED-9
  feed_9(company_id: string, payload: Omit<FEED_9, 'company_id'> = {}, raiseErrorToast: boolean = true): Observable<PaginationResponse<FeedPostResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `feed/public/company/${company_id}`, payload, options)
  }

  // ==================== TRAINER ENDPOINTS ====================

  // Get all active trainers (public) - TRN-1
  trn_1(payload: { page?: number; per_page?: number; search?: string; specialization?: string } = {}, raiseErrorToast: boolean = true): Observable<PaginationResponse<TrainerResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'trainers/', payload, options)
  }

  // Get trainer profile (public) - TRN-2
  trn_2(user_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<TrainerResponse>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `trainers/${user_id}`, {}, options)
  }

  // Create trainer subscription checkout - TRN-3
  trn_3(raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string }>> {
    return this.post(environment.coreApiUrl + 'trainers/subscribe', {}, {raiseErrorToast: raiseErrorToast})
  }

  // Update trainer profile - TRN-4
  trn_4(payload: TRN_4, raiseErrorToast: boolean = true): Observable<PutResponse<TrainerResponse>> {
    return this.put(environment.coreApiUrl + 'trainers/profile', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Cancel trainer subscription - TRN-5
  trn_5(raiseErrorToast: boolean = true): Observable<PostResponse<{ message: string; expires_at?: string }>> {
    return this.post(environment.coreApiUrl + 'trainers/cancel', {}, {raiseErrorToast: raiseErrorToast})
  }

  // Check if current user is a trainer - TRN-6
  trn_6(raiseErrorToast: boolean = true): Observable<GetResponse<TrainerStatusResponse>> {
    return this.get(environment.coreApiUrl + 'trainers/status', {}, {raiseErrorToast: raiseErrorToast})
  }

  // Get trainer's events (public) - TRN-7
  trn_7(user_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<{ upcoming_events: any[]; past_events: any[] }>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `trainers/${user_id}/events`, {}, options)
  }

  // Get trainer images (public) - TRN-8
  trn_8(user_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<any[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + `trainers/${user_id}/images`, {}, options)
  }

  // Upload trainer image - TRN-9
  trn_9(image: File, caption?: string, raiseErrorToast: boolean = true): Observable<PostResponse<any>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let formData = new FormData();
        formData.append('image', image);
        if (caption) {
          formData.append('caption', caption);
        }

        const options = { headers: headers };

        return this.http.post<PostResponse<any>>(environment.coreApiUrl + 'trainers/images', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  // Delete trainer image - TRN-10
  trn_10(image_id: number, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + `trainers/images/${image_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Update trainer image - TRN-11
  trn_11(image_id: number, payload: { caption?: string; position?: number }, raiseErrorToast: boolean = true): Observable<PutResponse<any>> {
    return this.put(environment.coreApiUrl + `trainers/images/${image_id}`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Reorder trainer images - TRN-12
  trn_12(image_ids: number[], raiseErrorToast: boolean = true): Observable<PutResponse<any[]>> {
    return this.put(environment.coreApiUrl + 'trainers/images/reorder', { image_ids }, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== TRAINER APPLICATION ENDPOINTS ====================

  // Submit trainer application - TRN-13
  trn_13(payload: TRN_13, raiseErrorToast: boolean = true): Observable<PostResponse<TrainerApplicationResponse>> {
    return this.post(environment.coreApiUrl + 'trainers/apply', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get current user's trainer application - TRN-14
  trn_14(raiseErrorToast: boolean = true): Observable<GetResponse<TrainerApplicationResponse | null>> {
    return this.get(environment.coreApiUrl + 'trainers/application', {}, {raiseErrorToast: raiseErrorToast})
  }

  // Withdraw pending trainer application - TRN-15
  trn_15(raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'trainers/application', {}, {raiseErrorToast: raiseErrorToast})
  }

  // Submit trainer recommendation - TRN-16
  trn_16(payload: TRN_16, raiseErrorToast: boolean = true): Observable<PostResponse<TrainerRecommendationResponse>> {
    return this.post(environment.coreApiUrl + 'trainers/recommend', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get all trainer applications (admin) - TRN-17
  trn_17(params: { page?: number; per_page?: number; status?: string } = {}, raiseErrorToast: boolean = true): Observable<GetResponse<{ applications: TrainerApplicationResponse[]; total: number; page: number; per_page: number }>> {
    return this.get(environment.coreApiUrl + 'trainers/admin/applications', params, {raiseErrorToast: raiseErrorToast})
  }

  // Approve trainer application (admin) - TRN-18
  trn_18(application_id: number, raiseErrorToast: boolean = true): Observable<PostResponse<TrainerApplicationResponse>> {
    return this.post(environment.coreApiUrl + `trainers/admin/applications/${application_id}/approve`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Reject trainer application (admin) - TRN-19
  trn_19(application_id: number, payload: TRN_19, raiseErrorToast: boolean = true): Observable<PostResponse<TrainerApplicationResponse>> {
    return this.post(environment.coreApiUrl + `trainers/admin/applications/${application_id}/reject`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get all trainer recommendations (admin) - TRN-20
  trn_20(params: { page?: number; per_page?: number; status?: string } = {}, raiseErrorToast: boolean = true): Observable<GetResponse<{ recommendations: TrainerRecommendationResponse[]; total: number; page: number; per_page: number }>> {
    return this.get(environment.coreApiUrl + 'trainers/admin/recommendations', params, {raiseErrorToast: raiseErrorToast})
  }

  // Mark recommendation as reviewed (admin) - TRN-21
  trn_21(recommendation_id: number, raiseErrorToast: boolean = true): Observable<PostResponse<TrainerRecommendationResponse>> {
    return this.post(environment.coreApiUrl + `trainers/admin/recommendations/${recommendation_id}/review`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== COMPANY SERVICES ENDPOINTS ====================

  // Get services for a company - CSR-1
  csr_1(company_id: string, raiseErrorToast: boolean = true): Observable<GetResponse<CompanyServiceResponse[]>> {
    return this.get(environment.coreApiUrl + 'company-services/', { company_id }, {raiseErrorToast: raiseErrorToast})
  }

  // Create a new service - CSR-2
  csr_2(payload: { company_id: string; service_name: string; service_description?: string; price_cents: number; currency?: string; vat_rate?: number }, raiseErrorToast: boolean = true): Observable<PostResponse<CompanyServiceResponse>> {
    return this.post(environment.coreApiUrl + 'company-services/', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Update a service - CSR-3
  csr_3(service_id: number, payload: { service_name?: string; service_description?: string; price_cents?: number; currency?: string; vat_rate?: number; is_active?: number }, raiseErrorToast: boolean = true): Observable<PutResponse<CompanyServiceResponse>> {
    return this.put(environment.coreApiUrl + `company-services/${service_id}`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete a service - CSR-4
  csr_4(service_id: number, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + `company-services/${service_id}`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Get orders for a company - CSR-5
  csr_5(payload: { company_id: string; status?: string; page?: number; per_page?: number }, raiseErrorToast: boolean = true): Observable<PaginationResponse<CompanyServiceOrderResponse[]>> {
    return this.get(environment.coreApiUrl + 'company-services/orders', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Create an order/invoice for a user - CSR-6
  csr_6(payload: {
    company_id: string;
    user_id?: string;
    user_email?: string;
    payment_type?: 'one_time' | 'subscription';
    due_date?: string;
    line_items: Array<{ service_id?: number; description?: string; quantity?: number; unit_price_cents?: number; vat_rate?: number }>
  }, raiseErrorToast: boolean = true): Observable<PostResponse<CompanyServiceOrderResponse>> {
    return this.post(environment.coreApiUrl + 'company-services/orders', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Create Stripe checkout for order payment - CSR-7
  csr_7(order_id: number, raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string }>> {
    return this.post(environment.coreApiUrl + `company-services/orders/${order_id}/pay`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Cancel an order - CSR-8
  csr_8(order_id: number, raiseErrorToast: boolean = true): Observable<PostResponse<{ cancelled: boolean; order_id: number }>> {
    return this.post(environment.coreApiUrl + `company-services/orders/${order_id}/cancel`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Create a subscription for a user - CSR-9
  csr_9(payload: {
    company_id: string;
    user_id?: string;
    user_email?: string;
    line_items: Array<{ service_id?: number; description?: string; quantity?: number }>
  }, raiseErrorToast: boolean = true): Observable<PostResponse<{ checkout_url: string; session_id: string; order_id: number }>> {
    return this.post(environment.coreApiUrl + 'company-services/subscriptions', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Cancel a subscription - CSR-10
  csr_10(order_id: number, raiseErrorToast: boolean = true): Observable<PostResponse<{ cancelled: boolean; order_id: number; message: string }>> {
    return this.post(environment.coreApiUrl + `company-services/subscriptions/${order_id}/cancel`, {}, {raiseErrorToast: raiseErrorToast})
  }

  // Get current user's service orders/invoices - CSR-11
  csr_11(payload: { status?: string; page?: number; per_page?: number } = {}, raiseErrorToast: boolean = true): Observable<PaginationResponse<CompanyServiceOrderResponse[]>> {
    return this.get(environment.coreApiUrl + 'company-services/user-orders', payload, {raiseErrorToast: raiseErrorToast})
  }

  // ============================================================================
  // TRAINING
  // ============================================================================

  // Training Packages
  aqh_trn_0(payload: AQH_TRN_0, raiseErrorToast: boolean = true): Observable<GetResponse<TrainingPackageResponse[]>> {
    return this.get(environment.coreApiUrl + 'training/packages', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_1(payload: AQH_TRN_1, raiseErrorToast: boolean = true): Observable<PostResponse<TrainingPackageResponse>> {
    return this.post(environment.coreApiUrl + 'training/packages', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_2(payload: AQH_TRN_2, raiseErrorToast: boolean = true): Observable<PutResponse<TrainingPackageResponse>> {
    return this.put(environment.coreApiUrl + 'training/packages', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_3(payload: AQH_TRN_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'training/packages', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Training Sessions (authenticated)
  aqh_trn_10(payload: AQH_TRN_10, raiseErrorToast: boolean = true): Observable<GetResponse<TrainingSessionResponse[]>> {
    return this.get(environment.coreApiUrl + 'training/sessions', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Training Sessions (public for event details page)
  aqh_trn_10_public(payload: AQH_TRN_10, raiseErrorToast: boolean = true): Observable<GetResponse<TrainingSessionResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'training/sessions/list/public', payload, options)
  }

  aqh_trn_11(payload: AQH_TRN_11, raiseErrorToast: boolean = true): Observable<PostResponse<TrainingSessionResponse>> {
    return this.post(environment.coreApiUrl + 'training/sessions', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_12(payload: AQH_TRN_12, raiseErrorToast: boolean = true): Observable<PutResponse<TrainingSessionResponse>> {
    return this.put(environment.coreApiUrl + 'training/sessions', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_13(payload: AQH_TRN_13, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'training/sessions', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Training Registrations
  aqh_trn_20(payload: AQH_TRN_20, raiseErrorToast: boolean = true): Observable<GetResponse<TrainingRegistrationResponse[]>> {
    return this.get(environment.coreApiUrl + 'training/registrations', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_21(payload: AQH_TRN_21, raiseErrorToast: boolean = true): Observable<PostResponse<TrainingRegistrationResponse>> {
    return this.post(environment.coreApiUrl + 'training/registrations', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_22(payload: AQH_TRN_22, raiseErrorToast: boolean = true): Observable<PutResponse<TrainingRegistrationResponse>> {
    return this.put(environment.coreApiUrl + 'training/registrations', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_23(payload: AQH_TRN_23, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'training/registrations', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Training Session Assignments
  aqh_trn_30(payload: AQH_TRN_30, raiseErrorToast: boolean = true): Observable<GetResponse<TrainingSessionAssignmentResponse[]>> {
    return this.get(environment.coreApiUrl + 'training/assignments', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_31(payload: AQH_TRN_31, raiseErrorToast: boolean = true): Observable<PostResponse<TrainingSessionAssignmentResponse>> {
    return this.post(environment.coreApiUrl + 'training/assignments', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_32(payload: AQH_TRN_32, raiseErrorToast: boolean = true): Observable<PutResponse<TrainingSessionAssignmentResponse>> {
    return this.put(environment.coreApiUrl + 'training/assignments', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_33(payload: AQH_TRN_33, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'training/assignments', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_34(payload: AQH_TRN_34, raiseErrorToast: boolean = true): Observable<PostResponse<{ created: TrainingSessionAssignmentResponse[]; errors: any[] }>> {
    return this.post(environment.coreApiUrl + 'training/assignments/bulk', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Day Capacity
  aqh_trn_40(payload: AQH_TRN_40, raiseErrorToast: boolean = true): Observable<GetResponse<TrainingDayCapacityResponse[]>> {
    return this.get(environment.coreApiUrl + 'training/day-capacity', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_41(payload: AQH_TRN_41, raiseErrorToast: boolean = true): Observable<PostResponse<TrainingDayCapacityResponse>> {
    return this.post(environment.coreApiUrl + 'training/day-capacity', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_trn_42(payload: AQH_TRN_42, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'training/day-capacity', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Package Days
  aqh_trn_43(payload: AQH_TRN_43, raiseErrorToast: boolean = true): Observable<PostResponse<TrainingPackageResponse>> {
    return this.post(environment.coreApiUrl + 'training/package-days', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Packages with availability (public for event details page)
  aqh_trn_44(payload: AQH_TRN_44, raiseErrorToast: boolean = true): Observable<GetResponse<TrainingPackageResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'training/packages/availability', payload, options)
  }

  // Public session assignments for event
  aqh_trn_45(payload: AQH_TRN_45, raiseErrorToast: boolean = false): Observable<GetResponse<TrainingSessionAssignmentResponse[]>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.get(environment.coreApiUrl + 'training/sessions/public', payload, options)
  }

  // ==================== MEMBERSHIP PRICING ====================

  // Get membership prices for a class
  aqh_eve_100(payload: AQH_EVE_100, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipPriceResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/class-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Set membership prices for a class (batch)
  aqh_eve_101(payload: AQH_EVE_101, raiseErrorToast: boolean = true): Observable<PostResponse<MembershipPriceResponse[]>> {
    return this.post(environment.coreApiUrl + 'events/class-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete membership price for a class
  aqh_eve_102(payload: AQH_EVE_102, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/class-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get membership prices for a package
  aqh_eve_103(payload: AQH_EVE_103, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipPriceResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/package-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Set membership prices for a package (batch)
  aqh_eve_104(payload: AQH_EVE_104, raiseErrorToast: boolean = true): Observable<PostResponse<MembershipPriceResponse[]>> {
    return this.post(environment.coreApiUrl + 'events/package-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete membership price for a package
  aqh_eve_105(payload: AQH_EVE_105, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/package-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get membership prices for a service
  aqh_eve_106(payload: AQH_EVE_106, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipPriceResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/service-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Set membership prices for a service (batch)
  aqh_eve_107(payload: AQH_EVE_107, raiseErrorToast: boolean = true): Observable<PostResponse<MembershipPriceResponse[]>> {
    return this.post(environment.coreApiUrl + 'events/service-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete membership price for a service
  aqh_eve_108(payload: AQH_EVE_108, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/service-membership-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get user prices for an event (with resolved membership discounts)
  aqh_eve_109(payload: AQH_EVE_109, raiseErrorToast: boolean = true): Observable<GetResponse<UserPricesResponse>> {
    return this.get(environment.coreApiUrl + 'events/user-prices', payload, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== EVENT CO-ORGANISERS ====================

  // Get co-organisers for an event
  aqh_eve_110(payload: AQH_EVE_110, raiseErrorToast: boolean = true): Observable<GetResponse<EventCoOrganiserResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/co-organisers', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Add co-organiser to event
  aqh_eve_111(payload: AQH_EVE_111, raiseErrorToast: boolean = true): Observable<PostResponse<EventCoOrganiserResponse>> {
    return this.post(environment.coreApiUrl + 'events/co-organisers', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Update co-organiser access level
  aqh_eve_112(payload: AQH_EVE_112, raiseErrorToast: boolean = true): Observable<PutResponse<EventCoOrganiserResponse>> {
    return this.put(environment.coreApiUrl + 'events/co-organisers', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Remove co-organiser from event
  aqh_eve_113(payload: AQH_EVE_113, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/co-organisers', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get events where company is a co-organiser
  aqh_eve_114(payload: AQH_EVE_114, raiseErrorToast: boolean = true): Observable<GetResponse<CoOrganisedEventResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/co-organised', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Search companies for co-organiser selection
  aqh_eve_115(payload: AQH_EVE_115, raiseErrorToast: boolean = true): Observable<PaginationResponse<CompanyResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/search', payload, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== SCORING SYSTEM ====================

  // Get scoring config for a class
  aqh_eve_120(payload: AQH_EVE_120, raiseErrorToast: boolean = true): Observable<any> {
    return this.get(environment.coreApiUrl + 'events/classes/scoring-config', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Create/Update scoring config
  aqh_eve_121(payload: AQH_EVE_121, raiseErrorToast: boolean = true): Observable<any> {
    return this.post(environment.coreApiUrl + 'events/classes/scoring-config', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get penalty presets for a class
  aqh_eve_122(payload: AQH_EVE_122, raiseErrorToast: boolean = true): Observable<any> {
    return this.get(environment.coreApiUrl + 'events/classes/penalties', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Add penalty preset
  aqh_eve_123(payload: AQH_EVE_123, raiseErrorToast: boolean = true): Observable<any> {
    return this.post(environment.coreApiUrl + 'events/classes/penalties', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Update penalty preset
  aqh_eve_124(payload: AQH_EVE_124, raiseErrorToast: boolean = true): Observable<any> {
    return this.put(environment.coreApiUrl + 'events/classes/penalties', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete penalty preset
  aqh_eve_125(payload: AQH_EVE_125, raiseErrorToast: boolean = true): Observable<any> {
    return this.delete(environment.coreApiUrl + 'events/classes/penalties', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get rounds for a class
  aqh_eve_126(payload: AQH_EVE_126, raiseErrorToast: boolean = true): Observable<any> {
    return this.get(environment.coreApiUrl + 'events/classes/rounds', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Create round
  aqh_eve_127(payload: AQH_EVE_127, raiseErrorToast: boolean = true): Observable<any> {
    return this.post(environment.coreApiUrl + 'events/classes/rounds', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Update round
  aqh_eve_128(payload: AQH_EVE_128, raiseErrorToast: boolean = true): Observable<any> {
    return this.put(environment.coreApiUrl + 'events/classes/rounds', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete round
  aqh_eve_129(payload: AQH_EVE_129, raiseErrorToast: boolean = true): Observable<any> {
    return this.delete(environment.coreApiUrl + 'events/classes/rounds', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get results for a class
  aqh_eve_130(payload: AQH_EVE_130, raiseErrorToast: boolean = true): Observable<any> {
    return this.get(environment.coreApiUrl + 'events/classes/results', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Create result
  aqh_eve_131(payload: AQH_EVE_131, raiseErrorToast: boolean = true): Observable<any> {
    return this.post(environment.coreApiUrl + 'events/classes/results', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Update result
  aqh_eve_132(payload: AQH_EVE_132, raiseErrorToast: boolean = true): Observable<any> {
    return this.put(environment.coreApiUrl + 'events/classes/results', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Delete result
  aqh_eve_133(payload: AQH_EVE_133, raiseErrorToast: boolean = true): Observable<any> {
    return this.delete(environment.coreApiUrl + 'events/classes/results', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Apply penalties to result
  aqh_eve_134(payload: AQH_EVE_134, raiseErrorToast: boolean = true): Observable<any> {
    return this.post(environment.coreApiUrl + 'events/classes/results/penalties', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get result by entry (for live session)
  aqh_eve_135(payload: AQH_EVE_135, raiseErrorToast: boolean = true): Observable<any> {
    return this.get(environment.coreApiUrl + 'events/classes/results/by-entry', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get final positions
  aqh_eve_136(payload: AQH_EVE_136, raiseErrorToast: boolean = true): Observable<any> {
    return this.get(environment.coreApiUrl + 'events/classes/final-positions', payload, {raiseErrorToast: raiseErrorToast})
  }

  // Save final positions
  aqh_eve_137(payload: AQH_EVE_137, raiseErrorToast: boolean = true): Observable<any> {
    return this.post(environment.coreApiUrl + 'events/classes/final-positions', payload, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== Event Cancellation ====================

  // Cancel event and process refunds
  aqh_eve_160(eventId: number, payload: AQH_EVE_160, raiseErrorToast: boolean = true): Observable<any> {
    return this.post(environment.coreApiUrl + `events/${eventId}/cancel`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Get manual refund requirements for cancelled event
  aqh_eve_161(eventId: number, payload: AQH_EVE_161, raiseErrorToast: boolean = true): Observable<any> {
    return this.get(environment.coreApiUrl + `events/${eventId}/manual-refunds`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // Mark manual refund as completed
  aqh_eve_162(requirementId: number, payload: AQH_EVE_162, raiseErrorToast: boolean = true): Observable<any> {
    return this.put(environment.coreApiUrl + `events/manual-refunds/${requirementId}/complete`, payload, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== EVENT TASKS ====================

  aqh_eve_170(payload: AQH_EVE_170, raiseErrorToast: boolean = true): Observable<GetResponse<EventTaskResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/tasks', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_171(payload: AQH_EVE_171, raiseErrorToast: boolean = true): Observable<PostResponse<EventTaskResponse>> {
    return this.post(environment.coreApiUrl + 'events/tasks', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_172(payload: AQH_EVE_172, raiseErrorToast: boolean = true): Observable<PutResponse<EventTaskResponse>> {
    return this.put(environment.coreApiUrl + 'events/tasks', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_173(payload: AQH_EVE_173, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/tasks', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_174(payload: AQH_EVE_174, raiseErrorToast: boolean = true): Observable<PutResponse<EventTaskResponse>> {
    return this.put(environment.coreApiUrl + 'events/tasks/toggle', payload, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== EVENT MEMBERS ====================

  aqh_eve_180(payload: AQH_EVE_180, raiseErrorToast: boolean = true): Observable<GetResponse<EventMemberResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/members', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_181(payload: AQH_EVE_181, raiseErrorToast: boolean = true): Observable<PostResponse<EventMemberResponse>> {
    return this.post(environment.coreApiUrl + 'events/members', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_182(payload: AQH_EVE_182, raiseErrorToast: boolean = true): Observable<PutResponse<EventMemberResponse>> {
    return this.put(environment.coreApiUrl + 'events/members', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_183(payload: AQH_EVE_183, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/members', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_184(raiseErrorToast: boolean = true): Observable<GetResponse<MyEventMembershipResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/my-events', {}, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_185(payload: AQH_EVE_185, raiseErrorToast: boolean = false): Observable<GetResponse<EventAccessResponse>> {
    return this.get(environment.coreApiUrl + 'events/access', payload, {raiseErrorToast: raiseErrorToast})
  }

  // ==================== NRYF INTEGRATION ====================

  // Fetch NRYF events
  aqh_eve_200(params?: { discipline_ids?: string, region_ids?: string, limit?: number, offset?: number }, raiseErrorToast: boolean = false): Observable<GetResponse<NryfEventResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/nryf/events', params || {}, { auth: false, raiseErrorToast: raiseErrorToast })
  }

  // Fetch NRYF masterdata (disciplines, regions)
  aqh_eve_201(raiseErrorToast: boolean = false): Observable<GetResponse<NryfMasterdataResponse>> {
    return this.get(environment.coreApiUrl + 'events/nryf/masterdata', {}, { auth: false, raiseErrorToast: raiseErrorToast })
  }

  // Fetch single NRYF event details
  aqh_eve_202(eventId: string, raiseErrorToast: boolean = false): Observable<GetResponse<NryfEventResponse>> {
    return this.get(environment.coreApiUrl + `events/nryf/event/${eventId}`, {}, { auth: false, raiseErrorToast: raiseErrorToast })
  }

  // ==================== ADMIN ====================

  // Get admin dashboard stats
  adm_dsh_0(raiseErrorToast: boolean = true): Observable<GetResponse<AdminDashboardStats>> {
    return this.get(environment.coreApiUrl + 'admin/dashboard', {}, { raiseErrorToast: raiseErrorToast })
  }

  // Get all users (paginated)
  adm_usr_0(params: { page?: number, per_page?: number, search?: string, order_by?: string, sort?: string, compact?: boolean, active_only?: boolean, is_trainer?: boolean } = {}, raiseErrorToast: boolean = true): Observable<PaginationResponse<AdminUserResponse[]>> {
    return this.get(environment.coreApiUrl + 'admin/users', params, { raiseErrorToast: raiseErrorToast })
  }

  // Get single user details
  adm_usr_1(userId: string, raiseErrorToast: boolean = true): Observable<GetResponse<AdminUserResponse>> {
    return this.get(environment.coreApiUrl + `admin/users/${userId}`, {}, { raiseErrorToast: raiseErrorToast })
  }

  // Get all companies (paginated)
  adm_coy_0(params: { page?: number, per_page?: number, search?: string, order_by?: string, sort?: string, compact?: boolean, company_type?: string, category_id?: number, active_only?: boolean } = {}, raiseErrorToast: boolean = true): Observable<PaginationResponse<AdminCompanyResponse[]>> {
    return this.get(environment.coreApiUrl + 'admin/companies', params, { raiseErrorToast: raiseErrorToast })
  }

  // Get single company details
  adm_coy_1(companyId: string, raiseErrorToast: boolean = true): Observable<GetResponse<AdminCompanyResponse>> {
    return this.get(environment.coreApiUrl + `admin/companies/${companyId}`, {}, { raiseErrorToast: raiseErrorToast })
  }

  // Search Google Places
  adm_plc_0(params: { query: string, location?: string }, raiseErrorToast: boolean = true): Observable<GetResponse<any[]>> {
    return this.get(environment.coreApiUrl + 'admin/places/search', params, { raiseErrorToast: raiseErrorToast })
  }

  // Add company from Google Places
  adm_plc_1(data: any, raiseErrorToast: boolean = true): Observable<GetResponse<any>> {
    return this.post(environment.coreApiUrl + 'admin/places/add', data, { raiseErrorToast: raiseErrorToast })
  }
}

